import { DSS_ROUTES, MIGRATED_ROUTES, MigratedRoute } from './migrated-routes';

/** Lança se o registro não tiver exatamente uma entrada para o path informado. */
function assertSingleRegistryEntry(routes: MigratedRoute[], path: string): void {
  const matches = routes.filter((route) => route.path === path).length;
  if (matches !== 1) {
    throw new Error(
      `MIGRATED_ROUTES deve conter exatamente uma entrada para '${path}' (encontradas: ${matches}).`,
    );
  }
}

assertSingleRegistryEntry(MIGRATED_ROUTES, '/timeline-eventos');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/configmodulos');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/migracao');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/home');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/contrato/list-contrato');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-bi-multiconta/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/log-webhook/list-log-webhook');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-webhook/list-log-webhook/visualizar-log-webhook/:id',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/log-consulta-erro');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/log-consulta-erro/detalhes/:idLog');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/configuracoes/list-configuracoes');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/configuracoes/list-configuracoes-conta/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/evento/list-psim-eventos/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/portaria-funcionario/list-portaria-funcionario');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/portaria-funcionario/area-portaria-funcionario');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/pages/softphone');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/sub-integrador/list-sub-integrador');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/sub-integrador/list-sub-integrador/add-sub-integrador',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/sub-integrador/list-sub-integrador/add-sub-integrador/:id',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/perfil-acesso/list-perfil-acesso');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/perfil-acesso/list-perfil-acesso/add-perfil-acesso');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/perfil-acesso/list-perfil-acesso/add-perfil-acesso/:paid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/horarios/list-horarios');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/horarios/list-horarios/add-horarios');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/horarios/list-horarios/add-horarios/:nhid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/inquilino/list-inquilino');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/inquilino/list-inquilino/add-inquilino');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/inquilino/list-inquilino/add-inquilino/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/inquilino/list-inquilino/visualizar-inquilino/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/estacionamento/list-estacionamento');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/estacionamento/list-estacionamento/add-estacionamento',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/estacionamento/list-estacionamento/add-estacionamento/:eid',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/estacionamento/list-estacionamento/add-parking-integration',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/vaga/list-vaga/:eid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/vaga/list-vaga/:eid/add-vaga');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/vaga/list-vaga/:eid/add-vaga/:vid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/vaga/list-vaga/:eid/vaga-cadastro-automatico/:eid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/fornecedor/list-fornecedor');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/fornecedor/list-fornecedor/add-fornecedor');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/fornecedor/list-fornecedor/add-fornecedor/:id');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/fornecedor/list-fornecedor/add-fornecedor/:id/:checkId',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/documento/list-documentos');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/documento/list-documentos/add-documento');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/documento/list-documentos/add-documento/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/documento/list-documentos/view-documento/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/categoria/list-categoria');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/categoria/list-categoria/add-categoria');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/categoria/list-categoria/add-categoria/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/credencial/list-credenciais');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/credencial/list-credenciais/add-credenciais');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/credencial/list-credenciais/add-credenciais/:cid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/credencial/vincular-credencial');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/cftv/list-cftv');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/cftv/list-cftv/add-cftv');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/cftv/list-cftv/add-cftv/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/manutencao-preventiva/list-manutencao-preventiva');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/manutencao-preventiva/list-manutencao-preventiva/add-manutencao-preventiva',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/manutencao-preventiva/list-manutencao-preventiva/add-manutencao-preventiva/:id/:checkId',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/zelador-ia');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/zelador-ia/add-dispositivo');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/zelador-ia/add-dispositivo/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/zelador-ia/dispositivo/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/portaria/list-portaria');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/portaria/list-portaria/add-portaria');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/portaria/list-portaria/add-portaria/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/log-notificacao/list-log-notificacao');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-notificacao/list-log-notificacao/visualizar-log-notificacao/:id/:tipo',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/log-notificacao/list-log-dispositivos');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-notificacao/list-log-dispositivos/visualizar-log-notificacao/:id/:tipo',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/conta/select-conta');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/conta/manage-conta');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/conta/migrar-conta');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/conta/list-conta');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/notificacao-tipo-evento/list-notificacao-tipo-evento/:id',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/notificacao-tipo-evento/list-notificacao-tipo-evento/:id/add-notificacao-tipo-evento',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/notificacao-tipo-evento/list-notificacao-tipo-evento/:id/add-notificacao-tipo-evento/:nid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-cameras/list-configcameras/:id');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/config-cameras/list-configcameras/:id/add-configcameras',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/config-cameras/list-configcameras/:id/add-configcameras/:cid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/cameras/list-cameras/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/cameras/list-cameras/:id/configurar-list-cameras');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/cameras/lpr-cameras/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/cameras/list-cameras-menu');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/cameras/list-cameras-menu/configurar-list-cameras');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-scond/list-key/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-scond/list-key/:id/configuracoes-porta/:pid');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/config-scond/list-key/:id/configuracoes-zona-porta/:id',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-scond/list-config-zonas/:id');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/config-scond/list-config-zonas/:id/configuracoes-zona-porta/:id',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/agendamento/list-agendamento');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/agendamento/list-agendamento/:aid');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/agendamento/list-agendamento/confirmar-agendamento-component/novo/:aid/:dtagenda',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/agendamento/list-agendamento/confirmar-agendamento-component/:aid/:eid',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/agendamento/list-agendamento/confirmar-agendamento-component/aprovar/:aid/:eid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/lista-convidados/list-lista-convidados');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/lista-convidados/list-lista-convidados/add-lista-convidados',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/lista-convidados/list-lista-convidados/add-lista-convidados/:id',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/area-comum/list-area-comum');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/area-comum/list-area-comum/add-area-comum');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/area-comum/list-area-comum/add-area-comum/:aid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/area-comum/list-area-comum/step-add-area-comum');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/area-comum/list-area-comum/step-add-area-comum/:aid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/lgpd/list-lgpd-termos-uso');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/lgpd/list-lgpd-termos-uso/add-lgpd/:tipo');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/lgpd/list-lgpd-termos-uso/add-lgpd/:tipo/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/lgpd/list-lgpd-politica-privacidade');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/lgpd/list-lgpd-politica-privacidade/add-lgpd/:tipo');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/lgpd/list-lgpd-politica-privacidade/add-lgpd/:tipo/:id',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/grupo-pessoa/list-grupo-pessoa');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/grupo-pessoa/list-grupo-pessoa/add-grupo-pessoa');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/grupo-pessoa/list-grupo-pessoa/add-grupo-pessoa/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/grupo-pessoa/list-grupo-pessoa/add-permissao-pessoa/');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/grupo-pessoa/list-grupo-pessoa/add-permissao-pessoa/:id',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/grupo-pessoa/list-grupo-pessoa/add-permissao-pessoa/:id/:isSigma',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/chamado/list-categoria-chamado');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/chamado/list-categoria-chamado/add-categoria-chamado');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/chamado/list-categoria-chamado/add-categoria-chamado/:id',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/chamado/list-chamado');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/chamado/list-chamado/add-chamado');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/chamado/list-chamado/add-chamado/:rid/:checkId');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/enquete/list-enquetes');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/enquete/list-enquetes/add-enquete');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/enquete/list-enquetes/add-enquete/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/enquete/list-enquetes/visualizar-enquete');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/enquete/list-enquetes/visualizar-enquete/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/enquete/list-enquetes/resultado-enquete');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/enquete/list-enquetes/resultado-enquete/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/voip/list-dispositivo-sip');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/voip/list-dispositivo-sip/add-dispositivo-sip');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/voip/list-dispositivo-sip/add-dispositivo-sip/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/voip/list-tronco');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/voip/list-tronco/add-tronco');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/voip/list-tronco/add-tronco/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/voip/config-voip');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/recado/list-recado');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/recado/list-recado/add-recado');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/recado/list-recado/add-recado/:rid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/recado/list-recado/view-recado');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/recado/list-recado/view-recado/:rid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/recado/list-recado/views-recado');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/recado/list-recado/views-recado/:rid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/assembleia/list-assembleia');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/assembleia/list-assembleia/assembleia/:id/pauta/:pautaId',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/assembleia/list-assembleia/assembleia/:id/pauta');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/assembleia/list-assembleia/assembleia/:id/votos');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/assembleia/list-assembleia/assembleia/:id/graficos');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/assembleia/list-assembleia/step-assembleia');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/assembleia/list-assembleia/step-assembleia/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/correspondencia/list-correspondencias');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/correspondencia/list-correspondencias/add-correspondencias',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/correspondencia/list-correspondencias/edit-correspondencias/:cid',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/correspondencia/list-correspondencias/entregar-component',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/correspondencia/list-correspondencias/entregar-component/:cid',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/correspondencia/list-correspondencias/visualizar-correspondencias',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/correspondencia/list-correspondencias/visualizar-correspondencias/:cid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/correspondencia/list-correspondencias-unidade');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/pessoa/list-pessoa');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/pessoa/list-pessoa/add-pessoa');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/pessoa/list-pessoa/add-pessoa/:pid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/pessoa/list-pessoa/pessoas/meus-dados/:pid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/pessoa/list-pessoa/pessoas/meus-dados/residents/:pid');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/pessoa/list-pessoa/pessoas/meus-dados/contact_address/:pid',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/pessoa/list-pessoa/pessoas/meus-dados/access_data/:pid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-chamado');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-agendamentos');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-chamadas');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-lgpd-distribuidor');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-lgpd-integrador');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-chamadas-integrador');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-primeiro-acesso');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-primeiro-acesso-conta');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-portaria');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-previsao-visita');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-unidades');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-acionamentos');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/relatorio/relatorio-veiculos');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/log-operacoes/list-log-operacoes');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-divisao/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-pessoa/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-unidade/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-previsao-visita/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-notificacao-eventos/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-key/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-key-config-portas/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-chave-virtual/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-chave-virtual-config-portas/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-log-operacoes/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/log-operacoes/list-log-operacoes/detalhes-mfa/:idRev/:idEntidade/:entidade',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/locker/app-locker');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/locker/app-locker/add-biccateca');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/locker/app-locker/add-biccateca/:cid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/locker/app-locker/add-locker');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/locker/app-locker/add-locker/:tipo');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/locker/list-biccateca');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/locker/list-biccateca/add-biccateca');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/locker/list-biccateca/add-biccateca/:cid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/locker/list-entrega-autonoma');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/locker/list-entrega-autonoma/add-entrega-autonoma');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/locker/list-entrega-autonoma/add-entrega-autonoma/:eid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-psim/configpsim-conexao/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-psim/configpsim-gerais');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-psim/configpsim-gerais/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-psim/step-configpsim/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-psim/step-configpsim/:id/configpsim-avancadas');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/config-psim/step-configpsim/:id/configpsim-avancadas-envio',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-psim/step-configpsim/:id/registrationAccess');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-psim/step-configpsim/:id/dataReceiving');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/config-psim/step-configpsim/:id/dataSending');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/equipamento/list-equipamento');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/equipamento/list-equipamento/add-equipamento');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/equipamento/list-equipamento/add-equipamento/:cid');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/equipamento/list-equipamento/add-equipamento/:cid/:nid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/equipamento/list-equipamento/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/equipamento/list-equipamento/:id/add-equipamento');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/equipamento/list-equipamento/:id/add-equipamento/:cid',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/equipamento/list-equipamento/:id/add-equipamento/:cid/:nid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/equipamento/porta-divisao-area');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/list-equipamento-hub');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/list-equipamento-hub/add-equipamento-hub');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/list-equipamento-hub/add-equipamento-hub/:cid');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/hub/list-equipamento-hub/add-equipamento-hub/:cid/:nid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/list-equipamento-hub/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/list-equipamento-hub/:id/add-equipamento-hub');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/hub/list-equipamento-hub/:id/add-equipamento-hub/:cid',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/hub/list-equipamento-hub/:id/add-equipamento-hub/:cid/:nid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/porta-hub');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/porta-hub/configuracoes-porta/:pid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/porta-hub/configuracoes-zona-porta/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/status-equipamento-hub');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/log-eventos-hub');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/hub/log-sincronizacao-hub');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/unidade/list-unidade');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/unidade/list-unidade/add-unidade');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/unidade/list-unidade/add-unidade/:uid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/unidade/list-unidade/add-unidade/:uid/add-pessoa');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/unidade/list-unidade/add-unidade/:uid/add-pessoa/:pid',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/unidade/list-unidade/add-unidade/:uid/vincular-pessoa-unidade',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/unidade/list-unidade/add-unidade/:uid/vincular-pessoa-unidade/add-pessoa',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/unidade/list-unidade/add-unidade/:uid/vincular-pessoa-unidade/add-pessoa/:pid',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/unidade/cadastro-automatico/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/unidade/divisoes/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/list-integrador');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/list-integrador/add-integrador');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/list-integrador/add-integrador/:id');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/integrador/list-integrador/add-integrador/:id/custom-skin',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/integrador/list-integrador/add-integrador/:id/contrato-integrador',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/integrador/list-integrador/add-integrador/:id/sms-view',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/integrador/list-integrador/add-integrador/:id/sms-view/sms-config',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/integrador/list-integrador/add-integrador/:id/config-integrador',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/integrador/list-integrador/add-integrador/:id/endereco-integrador',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/integrador/list-integrador/add-integrador/:id/migracao-contrato',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/sms-view');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/sms-view/sms-config');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/custom-skin-integrador');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/config-autenticacao');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/add-whatsapp');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/add-whatsapp/simular-envio');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/inicio');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/recado/list-recado');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/recado/list-recado/add-recado');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/recado/list-recado/add-recado/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/shield');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/integrador/add-pre-cadastro');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/meus-dados');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/alterar-senha');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/equipamento-pac/list-equipamento-pac');
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/equipamento-pac/list-equipamento-pac/add-equipamento-pac',
);
assertSingleRegistryEntry(
  MIGRATED_ROUTES,
  '/equipamento-pac/list-equipamento-pac/detalhes-equipamento-pac/:id',
);
assertSingleRegistryEntry(MIGRATED_ROUTES, '/convite-virtual');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/convite-virtual/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/chave-virtual');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/chave-virtual/:id');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/wizard');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/wizard/preCadastro/:pcid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/wizard/gestao/preCadastro/:pcid');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/pre-cadastro/list-pre-cadastro-component');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/modo-debug/list-modo-debug');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/modo-debug/list-modo-debug/buscar');
assertSingleRegistryEntry(MIGRATED_ROUTES, '/modo-debug/list-modo-debug/buscar/:id');

/**
 * Lista de rotas React registradas no roteador de topo.
 * Ao adicionar uma nova tela migrada para React, inclua o path aqui —
 * o Angular Router passará a ignorá-la automaticamente via ReactAwareUrlHandlingStrategy.
 */
export const REACT_ROUTES: string[] = [
  ...MIGRATED_ROUTES.map((route) => route.path),
  ...DSS_ROUTES,
];

// Side-effect: expõe as rotas no window para que ReactAwareUrlHandlingStrategy
// possa consultá-las sem acoplamento direto ao módulo React.
(window as Window & typeof globalThis & { __reactRoutes?: string[] }).__reactRoutes = REACT_ROUTES;
